/* GARDEN EQUIPMENT — Fiche produit (galerie, zoom, lightbox, variantes, qty, desc, accordéons) */
(function () {
  "use strict";

  var pdp = document.querySelector(".ge-pdp");
  if (!pdp) return;

  function money(cents) {
    try { return (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" }); }
    catch (e) { return (cents / 100).toFixed(2) + " €"; }
  }

  /* ---- Galerie : thumbnails ---- */
  var mainImg = pdp.querySelector("[data-ge-main-img]");
  var thumbs = Array.prototype.slice.call(pdp.querySelectorAll("[data-ge-thumb]"));
  var currentIndex = 0;
  var imgUrls = thumbs.map(function (t) { return t.querySelector("img").getAttribute("src"); });

  function bigUrl(u) { return u ? u.replace(/(_)\d+x(\.[a-z]+)/i, "$11200x$2").replace(/width=\d+/, "width=1200") : u; }

  thumbs.forEach(function (t, i) {
    t.addEventListener("click", function () {
      currentIndex = i;
      thumbs.forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
      var src = imgUrls[i];
      if (mainImg && src) {
        mainImg.src = src.replace(/(_)\d+x/i, "_1200x").replace(/width=\d+/, "width=1200");
        mainImg.setAttribute("data-src-full", src.replace(/(_)\d+x/i, "_1800x").replace(/width=\d+/, "width=1800"));
      }
    });
  });

  /* ---- Zoom au survol ---- */
  var zoom = pdp.querySelector("[data-ge-zoom]");
  if (zoom && window.matchMedia("(min-width: 768px)").matches) {
    zoom.addEventListener("mouseenter", function () { zoom.classList.add("is-zooming"); });
    zoom.addEventListener("mouseleave", function () { zoom.classList.remove("is-zooming"); mainImg.style.transformOrigin = "50% 50%"; });
    zoom.addEventListener("mousemove", function (e) {
      var r = zoom.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      if (mainImg) mainImg.style.transformOrigin = x + "% " + y + "%";
    });
  }

  /* ---- Lightbox ---- */
  var lb = pdp.querySelector("[data-ge-lightbox]");
  var lbImg = pdp.querySelector("[data-ge-lb-img]");
  function openLb() {
    if (!lb) return;
    lbImg.src = mainImg.getAttribute("data-src-full") || mainImg.src;
    lb.hidden = false; document.body.style.overflow = "hidden";
  }
  function closeLb() { if (lb) { lb.hidden = true; document.body.style.overflow = ""; } }
  if (zoom) zoom.addEventListener("click", openLb);
  pdp.addEventListener("click", function (e) {
    if (e.target.closest("[data-ge-lb-close]")) return closeLb();
    if (e.target === lb) return closeLb();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && lb && !lb.hidden) closeLb(); });

  /* ---- Variantes ---- */
  var variants = [];
  try { variants = JSON.parse(pdp.querySelector("[data-ge-variants]").textContent); } catch (e) {}
  var selected = {};
  pdp.querySelectorAll("[data-ge-opt]").forEach(function (group) {
    var pos = parseInt(group.getAttribute("data-ge-opt"), 10);
    var active = group.querySelector(".ge-pdp__pill.is-active");
    if (active) selected[pos] = active.getAttribute("data-ge-val");
  });

  function findVariant() {
    return variants.find(function (v) {
      return Object.keys(selected).every(function (pos) {
        return v["option" + pos] === selected[pos];
      });
    });
  }

  function updateVariant() {
    var v = findVariant();
    if (!v) return;
    var idInput = pdp.querySelector("[data-ge-variant-id]");
    if (idInput) idInput.value = v.id;
    var priceEl = pdp.querySelector("[data-ge-price]");
    if (priceEl) priceEl.textContent = money(v.price);
    var cmp = pdp.querySelector("[data-ge-compare]");
    if (cmp) {
      if (v.compare_at_price && v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; }
      else { cmp.hidden = true; }
    }
    var dot = pdp.querySelector("[data-ge-stock] .ge-pdp__dot");
    var stxt = pdp.querySelector("[data-ge-stock-txt]");
    var addBtn = pdp.querySelector("[data-ge-add]");
    var addLbl = pdp.querySelector("[data-ge-add-label]");
    if (v.available) {
      if (dot) dot.classList.remove("ge-pdp__dot--out");
      if (stxt) stxt.textContent = "En stock";
      if (addBtn) addBtn.disabled = false;
      if (addLbl) addLbl.textContent = "Ajouter au panier";
    } else {
      if (dot) dot.classList.add("ge-pdp__dot--out");
      if (stxt) stxt.textContent = "Rupture";
      if (addBtn) addBtn.disabled = true;
      if (addLbl) addLbl.textContent = "Rupture de stock";
    }
  }

  pdp.querySelectorAll("[data-ge-opt] .ge-pdp__pill").forEach(function (pill) {
    pill.addEventListener("click", function () {
      var group = pill.closest("[data-ge-opt]");
      var pos = parseInt(group.getAttribute("data-ge-opt"), 10);
      group.querySelectorAll(".ge-pdp__pill").forEach(function (p) { p.classList.remove("is-active"); });
      pill.classList.add("is-active");
      selected[pos] = pill.getAttribute("data-ge-val");
      updateVariant();
    });
  });

  /* ---- Quantité ---- */
  var qtyInput = pdp.querySelector("[data-ge-qty]");
  pdp.addEventListener("click", function (e) {
    if (!qtyInput) return;
    var q = parseInt(qtyInput.value, 10) || 1;
    if (e.target.closest("[data-ge-qty-dec]")) qtyInput.value = Math.max(1, q - 1);
    if (e.target.closest("[data-ge-qty-inc]")) qtyInput.value = q + 1;
    syncProTiers();
  });
  if (qtyInput) qtyInput.addEventListener("input", syncProTiers);
  if (qtyInput) qtyInput.addEventListener("change", syncProTiers);

  /* ---- Tarifs pro dégressifs (miroir du bloc ESPACE PRO React) ----
     Actif seulement en mode pro (html.ge-is-pro). Lit les paliers "qty|prixCents",
     calcule le prix pro unitaire pour la quantité choisie (palier le plus élevé
     atteint), met à jour « Votre tarif pro » et pose la propriété de ligne
     properties[_pro_unit_ht] (en euros) sur le formulaire d'ajout. */
  /* Compte pro B2B : mêmes paliers affichés, mais Shopify les applique lui-même au panier. */
  var isB2B = document.documentElement.classList.contains("ge-is-b2b");
  var isPro = isB2B || document.documentElement.classList.contains("ge-is-pro");
  var proBox = pdp.querySelector("[data-ge-protiers]");
  var proForm = pdp.querySelector("[data-ge-product-form]");
  var proTiers = [];
  var proTierBtns = Array.prototype.slice.call(pdp.querySelectorAll("[data-ge-protier]"));
  (function () {
    var el = pdp.querySelector("[data-ge-pro-tiers]");
    if (!el) return;
    try {
      var raw = JSON.parse(el.textContent) || "";
      String(raw).split(";").forEach(function (t) {
        if (!t) return;
        var p = t.split("|");
        var q = parseInt(p[0], 10);
        var cents = parseInt(p[1], 10);
        if (q > 0 && cents > 0) proTiers.push({ minQty: q, cents: cents });
      });
      proTiers.sort(function (a, b) { return a.minQty - b.minQty; });
    } catch (e) {}
  })();

  /* Prix pro unitaire (centimes) pour une quantité : palier le plus élevé atteint, sinon null. */
  function proUnitCents(qty) {
    var price = null;
    for (var i = 0; i < proTiers.length; i++) {
      if (qty >= proTiers[i].minQty) price = proTiers[i].cents;
    }
    return price;
  }

  /* Hidden input properties[_pro_unit_ht] posé sur le form UNIQUEMENT en mode pro. */
  function setProUnitProperty(euros) {
    if (!proForm) return;
    var input = proForm.querySelector('[data-ge-pro-unit-ht]');
    if (euros == null) {
      if (input) input.parentNode.removeChild(input);
      return;
    }
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_pro_unit_ht]";
      input.setAttribute("data-ge-pro-unit-ht", "");
      proForm.appendChild(input);
    }
    input.value = euros.toFixed(2);
  }

  function syncProTiers() {
    if (!isPro || !proBox || !proTiers.length) return;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var cents = proUnitCents(qty);

    var yourBox = proBox.querySelector("[data-ge-protiers-your]");
    var minBox = proBox.querySelector("[data-ge-protiers-min]");
    if (cents != null) {
      var unitEl = proBox.querySelector("[data-ge-protiers-unit]");
      var calcEl = proBox.querySelector("[data-ge-protiers-calc]");
      if (unitEl) unitEl.textContent = money(cents);
      if (calcEl) calcEl.innerHTML = qty + " × " + money(cents) + " = <strong>" + money(cents * qty) + " HT</strong>";
      if (yourBox) yourBox.hidden = false;
      if (minBox) minBox.hidden = true;
      if (!isB2B) setProUnitProperty(cents / 100);
    } else {
      if (yourBox) yourBox.hidden = true;
      if (minBox) {
        var minQtyEl = minBox.querySelector("[data-ge-protiers-min-qty]");
        if (minQtyEl) minQtyEl.textContent = proTiers[0].minQty;
        minBox.hidden = false;
      }
      setProUnitProperty(null);
    }

    /* Palier actif = le plus avantageux atteint pour la quantité choisie. */
    var activeIdx = -1;
    for (var i = 0; i < proTiers.length; i++) { if (qty >= proTiers[i].minQty) activeIdx = i; }
    proTierBtns.forEach(function (b, i) { b.classList.toggle("is-active", i === activeIdx); });
  }

  /* Clic sur un palier → règle la quantité au seuil du palier. */
  proTierBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      var q = parseInt(b.getAttribute("data-qty"), 10) || 1;
      if (qtyInput) qtyInput.value = q;
      syncProTiers();
    });
  });

  if (isPro) syncProTiers();

  /* ---- Description ---- */
  var descToggle = pdp.querySelector("[data-ge-desc-toggle]");
  if (descToggle) {
    descToggle.addEventListener("click", function () {
      var wrap = descToggle.closest(".ge-pdp__desc-wrap");
      var desc = wrap.querySelector("[data-ge-desc]");
      var label = wrap.querySelector("[data-ge-desc-label]");
      var open = desc.classList.toggle("is-expanded");
      wrap.classList.toggle("is-open", open);
      descToggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (label) label.textContent = open ? "Voir moins" : "Voir la description complète";
    });
  }

  /* ---- Accordéons ---- */
  pdp.querySelectorAll("[data-ge-acc-item] [data-ge-acc-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest("[data-ge-acc-item]");
      var open = item.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
})();
